export enum OrderStatus {
    PENDING = 'PENDING',
    PROGRESS = 'PROGRESS',
    READY = 'READY',
    FINISHED = 'FINISHED',
    DELETED = 'DELETED',
}



// WEBPACK FOOTER //
// ./src/model/lib/enums/OrderStatus.ts